import Image from "next/image";
import styles from "./HolisticEducation.module.css";

interface TileDescription {
  id: number;
  title: string;
  description: string;
}

interface Image {
  id: number;
  documentId: string;
  url: string;
  alternativeText: string;
}

interface HolisticEducationData {
  id: number;
  title_description: TileDescription;
  images: Image[];
}
interface Props {
  data: HolisticEducationData;
}

const HolisticEducation: React.FC<Props> = ({ data }) => {
  const { title_description, images } = data;
  return (
    <div className="container">
      <div className={styles.innerContainer}>
        <div className={styles.right}>
          <h4>{title_description?.title}</h4>
          <p>{title_description?.description}</p>
        </div>
        <div className={styles.left}>
          <Image
            src={images[0]?.url}
            alt={images[0]?.alternativeText || "Holistic Education"}
            title={images[0]?.alternativeText || "Holistic Education"}
            className={styles.image}
            width={616}
            height={324}
            priority
          />
        </div>
      </div>
    </div>
  );
};

export default HolisticEducation;
